import axios from 'axios';
import { API_BASE_URL } from '../utils/config';

const BASE_URL = API_BASE_URL;

/**
 * Get the authorization URL for Salesforce OAuth.
 * Opens in a new window/popup for the user to log in.
 */
export const initiateSalesforceOAuth = async (token, domain = null) => {
  const params = domain ? { params: { domain } } : {};
  const response = await axios.get(`${BASE_URL}/api/auth/salesforce`, {
    headers: { Authorization: `Bearer ${token}` },
    ...params,
  });
  // Backend returns { auth_url: "https://login.salesforce.com/..." }
  return response.data.auth_url;
};

/**
 * Get the authorization URL for Box OAuth.
 */
export const initiateBoxOAuth = async (token) => {
  const response = await axios.get(`${BASE_URL}/api/auth/box`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.auth_url;
};

/**
 * Connect Snowflake with username/password or private key.
 */
export const connectSnowflake = async (credentials, token) => {
  const response = await axios.post(
    `${BASE_URL}/api/auth/snowflake/connect`,
    credentials,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

/**
 * Get connection status for all services.
 */
export const getAllConnectionStatuses = async (token) => {
  const response = await axios.get(`${BASE_URL}/api/auth/status`, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 10000, // 10 second timeout
  });
  return response.data;
};

/**
 * Get connection status for a single service.
 */
export const getServiceStatus = async (serviceType, token) => {
  const response = await axios.get(`${BASE_URL}/api/auth/status/${serviceType}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Disconnect a service (remove stored credentials).
 */
export const disconnectService = async (serviceType, token) => {
  const response = await axios.delete(`${BASE_URL}/api/auth/disconnect/${serviceType}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Test if a service connection is still valid.
 */
export const testConnection = async (serviceType, token) => {
  const response = await axios.post(
    `${BASE_URL}/api/oauth/test/${serviceType}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};
